<div class="mat-typography mat-drawer-container webview-content">
  <ng-container *ngIf="loading">
    <div class="spinner" [ngClass]="{ height: addExtraHeight }">
      <mat-spinner></mat-spinner>
      <h2 class="margin-top">Loading... Please wait.</h2>
    </div>
  </ng-container>
  <router-outlet></router-outlet>
</div>
